module.exports = __webpack_public_path__ + "static/media/Coral.929bc3b0.jpg";